import { FC, ReactNode, useMemo } from 'react';
import { selectors, useAppSelector } from 'store';
import { ThemeProvider } from 'styled-components';
import { Theme } from 'styles/themes';
import { appDefaultColors } from 'styles/themes/appDefaultColors';
import { getCoursePrimaryColor } from 'utils';

import MonetizationLightModeContext from './MonetizationLightModeContext';

type MonetizationLightModeProviderProps = {
  children: ReactNode;
};

const MonetizationLightModeProvider: FC<MonetizationLightModeProviderProps> = ({ children }) => {
  const direction = useAppSelector(selectors.direction.selectDirection);
  const activeCourse = useAppSelector(selectors.courses.selectActiveCourse);
  const selectedCourse = useAppSelector(selectors.courses.selectCourse);
  const publicCourse = useAppSelector(selectors.courses.selectPublicCourse);

  const theme = useMemo(() => {
    const themeCourse = selectedCourse || activeCourse || publicCourse;
    const primaryColor = getCoursePrimaryColor(themeCourse, direction?.mainColorHex);

    return new Theme(primaryColor, appDefaultColors.default, {
      old: direction?.oldColorHex || '',
    });
  }, [activeCourse, selectedCourse, publicCourse, direction?.mainColorHex, direction?.oldColorHex]);

  return (
    <MonetizationLightModeContext.Provider value={{ forceLightMode: true }}>
      {/* @ts-ignore - ThemeProvider type compatibility issue with React 18 */}
      <ThemeProvider theme={theme.default}>{children}</ThemeProvider>
    </MonetizationLightModeContext.Provider>
  );
};

export default MonetizationLightModeProvider;
